// Backend base URLs. Read once at module load through the central
// env reader (lib/env.ts) so a missing var fails at boot rather than
// surfacing as a fetch to "undefined/auth/login".

import { env } from "../env";

function trimTrailingSlash(s: string): string {
  return s.endsWith("/") ? s.slice(0, -1) : s;
}

export const AUTH_BASE = trimTrailingSlash(env.authBaseUrl);
export const CORE_BASE = trimTrailingSlash(env.apiBaseUrl);
export const MEDIA_BASE = trimTrailingSlash(env.mediaBaseUrl);

export type ApiBase = "auth" | "core" | "media";

export function baseFor(target: ApiBase): string {
  if (target === "auth") return AUTH_BASE;
  if (target === "core") return CORE_BASE;
  return MEDIA_BASE;
}
